import React from "react";

const CloseButton = ({ onClick, ...props }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "20px",
      padding: "5px",
      ...props.style,
    }}
    {...props}
  >
    ×
  </button>
);

export default CloseButton;
